import { TappIcon } from '@/components/ui/TappIcon';
import { TappInput } from '@/components/ui/TappInput';
import { Button } from '@/components/ui/button';
import { zodResolver } from '@hookform/resolvers/zod';
import { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { z } from 'zod';
import AppError from '@/components/AppError';
import { useAuth } from '@/lib/auth.store';
import { useTranslation } from 'react-i18next';

const ForgotPasswordPage = () => {
  const { t } = useTranslation();
  const [error, setError] = useState<any>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const auth = useAuth();

  const {
    handleSubmit,
    control,
    formState: { isSubmitting },
  } = useForm({
    resolver: zodResolver(
      z.object({
        email: z.string().email(t('invalidEmail')),
      })
    ),
    defaultValues: {
      email: '',
    },
  });

  const onSubmit = async (data: any) => {
    try {
      setError(null);
      setSuccess(null);

      const res = await auth.requestPasswordReset(data.email);
      setSuccess(res.message);
    } catch (err) {
      setError(err);
    }
  };

  return (
    <main className="flex flex-col items-center justify-center px-2 py-16">
      <div className="mb-6 h-14 w-14">
        <img src="/logo_small.png" alt="Logo" />
      </div>

      <h1 className="mb-6 text-center text-2xl font-semibold tracking-tight">{t('forgotPasswordTitle')}</h1>

      <form
        onSubmit={handleSubmit(onSubmit)}
        className="flex w-full max-w-xs flex-1 flex-col items-center justify-center"
      >
        <Controller
          name="email"
          control={control}
          render={({ field, fieldState }) => (
            <TappInput
              className="mb-4 w-full"
              border
              type="email"
              placeholder={t('forgotPasswordEmailPlaceholder')}
              prefix={<TappIcon>mail</TappIcon>}
              {...field}
              {...fieldState}
            />
          )}
        />

        <Button className="w-full" type="submit" disabled={isSubmitting}>
          {t('forgotPasswordSendResetLink')}
        </Button>

        <AppError error={error} className="mt-4" />
        {success && <p className="mt-4 text-sm text-green-600 text-center">{success}</p>}
      </form>
    </main>
  );
};

export default ForgotPasswordPage;
